// 만세력 계산. 서버 SajuCalculator.java 를 그대로 옮긴 것이다(알고리즘 변경 없음).
// 절기는 태양 황경 공식으로 계산 — 오차 약 ±10분.
export const STEMS = ['갑','을','병','정','무','기','경','신','임','계'];
export const BRANCHES = ['자','축','인','묘','진','사','오','미','신','유','술','해'];
export const EL_NAME = ['목','화','토','금','수'];
export const GROUPS = ['비겁','식상','재성','관성','인성'];
export const STEM_EL = [0,0,1,1,2,2,3,3,4,4];
export const BRANCH_MAIN_STEM = [9,5,0,1,4,2,3,5,6,7,4,8];
export const SIPSEONG = ['비견','겁재','식신','상관','편재','정재','편관','정관','편인','정인'];
const JEOL = [315,345,15,45,75,105,135,165,195,225,255,285];
const JEOL_DATE = [[2,4],[3,6],[4,5],[5,6],[6,6],[7,7],[8,8],[9,8],[10,8],[11,8],[12,7],[1,6]];
const KST = 9 / 24;
const rad = (d) => (d * Math.PI) / 180;

export const mod = (a, n) => ((a % n) + n) % n;
export const pillar = (stem, branch) => ({ stem, branch, text: STEMS[stem] + BRANCHES[branch] });

export function julianDay(y, m, d, h) {
  if (m <= 2) { y--; m += 12; }
  const a = Math.trunc(y / 100), b = 2 - a + Math.trunc(a / 4);
  return Math.floor(365.25 * (y + 4716)) + Math.floor(30.6001 * (m + 1)) + d + b - 1524.5 + h / 24;
}
export function sunLongitude(jd) {
  const t = (jd - 2451545) / 36525;
  const l0 = 280.46646 + 36000.76983 * t + 0.0003032 * t * t;
  const m = 357.52911 + 35999.05029 * t - 0.0001537 * t * t;
  const c = (1.914602 - 0.004817 * t - 0.000014 * t * t) * Math.sin(rad(m))
    + (0.019993 - 0.000101 * t) * Math.sin(rad(2 * m)) + 0.000289 * Math.sin(rad(3 * m));
  const om = 125.04 - 1934.136 * t;
  return mod(l0 + c - 0.00569 - 0.00478 * Math.sin(rad(om)), 360);
}
export const jdFromKst = (y, m, d, hh, mm) => julianDay(y, m, d, hh + mm / 60) - KST;

/** → [y, m, d, hh, mm] KST */
export function kstFromJd(jd) {
  const z = jd + KST + 0.5, zi = Math.floor(z), f = z - zi;
  const a0 = Math.floor((zi - 1867216.25) / 36524.25);
  const a = zi + 1 + a0 - Math.trunc(a0 / 4), b = a + 1524, c = Math.floor((b - 122.1) / 365.25);
  const d0 = Math.floor(365.25 * c), e = Math.floor((b - d0) / 30.6001);
  const day = b - d0 - Math.floor(30.6001 * e);
  const month = e < 14 ? e - 1 : e - 13;
  const year = month > 2 ? c - 4716 : c - 4715;
  const mins = Math.round(f * 1440);
  return [year, month, day, Math.trunc(mins / 60), mins % 60];
}
export function solveTerm(target, guess) {
  let jd = guess;
  for (let i = 0; i < 30; i++) {
    const diff = mod(target - sunLongitude(jd) + 180, 360) - 180;
    jd += diff / 0.9856;
    if (Math.abs(diff) < 1e-6) break;
  }
  return jd;
}
function jeolJd(year, idx) {
  const y = idx === 11 ? year + 1 : year;
  return solveTerm(JEOL[idx], jdFromKst(y, JEOL_DATE[idx][0], JEOL_DATE[idx][1], 12, 0));
}
export function dayPillarIdx(y, m, d) {
  const jdn = Math.floor(julianDay(y, m, d, 12) + 0.5);
  return mod(jdn + 49, 60);
}

/** hh, mm 은 null 가능(시각 미입력). → { year, month, day, hour(null 가능), lon } */
export function compute(y, m, d, hh, mm, ziSplit, offsetMin) {
  const hasTime = hh != null;
  const jd = jdFromKst(y, m, d, hasTime ? hh : 12, hasTime && mm != null ? mm : 0) + offsetMin / 1440;
  const t = kstFromJd(jd);
  const lon = sunLongitude(jd);
  const sy = jd < jeolJd(t[0], 0) ? t[0] - 1 : t[0];
  const year = pillar(mod(sy - 4, 10), mod(sy - 4, 12));
  const mi = Math.floor(mod(lon - 315, 360) / 30);
  const month = pillar(mod((year.stem % 5) * 2 + 2 + mi, 10), mod(mi + 2, 12));
  let dayIdx = dayPillarIdx(t[0], t[1], t[2]);
  if (hasTime && ziSplit && t[3] >= 23) dayIdx = mod(dayIdx + 1, 60);
  const day = pillar(dayIdx % 10, dayIdx % 12);
  let hour = null;
  if (hasTime) {
    const hb = Math.trunc((t[3] + 1) / 2) % 12;
    hour = pillar(mod((day.stem % 5) * 2 + hb, 10), hb);
  }
  return { year, month, day, hour, lon };
}

export function sipseong(dayStem, other) {
  const rel = mod(STEM_EL[other] - STEM_EL[dayStem], 5);
  const same = dayStem % 2 === other % 2;
  return SIPSEONG[[0, 2, 4, 6, 8][rel] + (same ? 0 : 1)];
}
export function groupOf(s) {
  if (s === '비견' || s === '겁재') return '비겁';
  if (s === '식신' || s === '상관') return '식상';
  if (s === '편재' || s === '정재') return '재성';
  if (s === '편관' || s === '정관') return '관성';
  return '인성';
}
export function elements(s) {
  const c = [0, 0, 0, 0, 0];
  for (const p of [s.year, s.month, s.day, s.hour]) {
    if (!p) continue;
    c[STEM_EL[p.stem]]++; c[STEM_EL[BRANCH_MAIN_STEM[p.branch]]]++;
  }
  const n = c.reduce((a, b) => a + b, 0);
  return c.map((v) => Math.round((v * 100) / n));
}

export function daewoon(y, m, d, hh, mm, offsetMin, s, gender, count) {
  const yang = s.year.stem % 2 === 0;
  const forward = (yang && gender === 'M') || (!yang && gender === 'F');
  const jd = jdFromKst(y, m, d, hh != null ? hh : 12, hh != null && mm != null ? mm : 0) + offsetMin / 1440;
  const mi = Math.floor(mod(sunLongitude(jd) - 315, 360) / 30);
  const target = forward ? JEOL[(mi + 1) % 12] : JEOL[mi];
  const tjd = solveTerm(target, jd + (forward ? 15 : -15));
  const startAge = Math.abs(tjd - jd) / 3;
  const list = [];
  let st = s.month.stem, br = s.month.branch;
  const k = forward ? 1 : -1;
  for (let i = 1; i <= count; i++) {
    st = mod(st + k, 10); br = mod(br + k, 12);
    list.push({ age: Math.round((startAge + (i - 1) * 10) * 10) / 10, stem: st, branch: br });
  }
  return { forward, startAge, list };
}
